import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Title, Empty } from 'src/components/Ant'
import { A4_PORTRAIT } from 'src/views/Management/Reports/types'

import { WrapSpacer, WrapTableDiv } from './styles'
import { Footer, OptionsBar, TitleReport } from '..'
import { WrapPageContent, WrapPage } from '../../styles'
import { SectionHeader, TableDetail } from './components'

enum mesures {
  PAGE_HEIGHT = 1030,
  MAX_REGISTER_PER_PAGE = 41,
  MINIMUN_TABLE = 95,
  SECTION_HEADER = 95,
  SECTION_TITLE = 66,
  SINGLE_REGISTER = 21,
  SPACER = 20,
  TABLE_HEADER = 38,
  USER_NAME = 36
}

function R3() {
  const {
    reports: {
      reportsResources: {
        R3Data: { data }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (!data.length) {
      return [
        [
          <TitleReport title="web.report.3.title" />,
          <SectionHeader />,
          <Empty />
        ]
      ]
    }

    const tempPages: JSX.Element[][] = []

    let activeUserName = ''
    let index = 0
    let isFirtPage = true

    // Make pages containing receipts grouped by owner //
    do {
      const page: JSX.Element[] = []
      let avaliableSpace = mesures.PAGE_HEIGHT

      avaliableSpace -= mesures.SECTION_TITLE
      page.push(<TitleReport title="web.report.3.title" />)

      if (isFirtPage) {
        isFirtPage = false
        avaliableSpace -= mesures.SECTION_HEADER
        page.push(<SectionHeader />)
      }

      while (index < data.length && avaliableSpace > mesures.MINIMUN_TABLE) {
        activeUserName = data[index].participant_name

        const maxRecordsPossible = data.slice(
          index,
          index + mesures.MAX_REGISTER_PER_PAGE
        )
        const amountUserRegisters = maxRecordsPossible.filter(
          // eslint-disable-next-line
          itinerary =>
            itinerary.participant_number === data[index].participant_number
        ).length

        if (amountUserRegisters > 0) {
          let spaceForRegisters = Math.trunc(
            (avaliableSpace - mesures.TABLE_HEADER - mesures.USER_NAME) /
              mesures.SINGLE_REGISTER
          )

          const range =
            amountUserRegisters < spaceForRegisters
              ? amountUserRegisters
              : spaceForRegisters
          avaliableSpace -= mesures.USER_NAME
          page.push(<Title level={4}>{activeUserName}</Title>)

          const rangeToPrint = data.slice(index, index + range)
          avaliableSpace -=
            mesures.TABLE_HEADER + mesures.SINGLE_REGISTER * range
          page.push(
            <WrapTableDiv>
              <TableDetail dataSource={rangeToPrint} />
            </WrapTableDiv>
          )

          if (avaliableSpace >= mesures.SPACER) {
            avaliableSpace -= mesures.SPACER
            page.push(<WrapSpacer />)
          }

          index += range
        }
      }
      tempPages.push(page)
    } while (index < data.length)

    return tempPages
  }, [data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R3
